module.exports = __webpack_public_path__ + "media/assets/images/blog/WhatsApp-AmazonConnect-small-10d2e49d1510fb224b4ee8778a4d05bd.jpeg";